<template>
    <div class="page-employee-archives">
        <div class="toolbars mrgb5">
            <div class="buttons mrgb5">
                <div class="fl">
                    <!-- 手动入职 -->
                    <el-button class="mrgr5 mrgb5" type="primary" size="medium" @click="_hire()" v-if="isEmployeeArchiveManage">
                        <i class="fa fa-user-plus"></i> 手动入职
                    </el-button>
                    <!-- 钉钉数据：钉钉审批同步 / 钉钉审批 Excel 上传 -->
                    <el-dropdown class="mrgr5 mrgb5" trigger="click" @command="handleDingtalkCommand" v-if="isEmployeeArchiveManage">
                        <el-button type="success" size="medium">
                            <i class="fa fa-cloud"></i> 钉钉数据 <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="sync"><i class="fa fa-refresh"></i> 同步</el-dropdown-item>
                            <el-dropdown-item command="upload"><i class="fa fa-file-excel-o"></i> 上传</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <!-- 档案数据：导入/导出档案（导出的 Excel 修改后可回导，可更新可新增） -->
                    <el-button class="mrgr5 mrgb5" type="warning" plain size="medium" @click="_importArchive()" v-if="isEmployeeArchiveManage">
                        <i class="fa fa-upload"></i> 导入档案
                    </el-button>
                    <el-button class="mrgr5 mrgb5" type="warning" plain size="medium" @click="_export()">
                        <i class="fa fa-download"></i> 导出档案
                    </el-button>
                    <!-- 功能说明 -->
                    <el-button class="mrgr5 mrgb5" size="medium" @click="helping = true">
                        <i class="fa fa-question-circle-o"></i> 功能说明
                    </el-button>
                </div>
                <div class="fr">
                    <!-- 在职状态 -->
                    <el-select class="c-el-input mrgr5 mrgb5" v-model="listQuery.status" placeholder="在职状态" clearable
                        size="medium" @change="_search()">
                        <el-option v-for="item in arrEmployeeStatus" :key="'status-' + item.value" :label="item.desc"
                            :value="item.value"></el-option>
                    </el-select>
                    <!-- 搜索内容 -->
                    <el-input class="c-el-input mrgr5 mrgb5" placeholder="姓名/身份证号/手机号" clearable v-model="listQuery.keywords"
                        size="medium" @keyup.enter.native="_search()"></el-input>
                    <el-button class="mrgb5" type="primary" size="medium" @click="_search()"><i class="fa fa-search"></i> 查询</el-button>
                </div>
                <div class="clearb"></div>
            </div>
        </div>
        <div>
            <!-- 数据表格 -->
            <el-table ref="employeeTable" :data="tableData" style="width: 100%" border size="small">
                <el-table-column label="姓名" prop="name" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column label="身份证号" prop="idNumber" width="180" show-overflow-tooltip></el-table-column>
                <el-table-column label="手机号" prop="tel" width="120"></el-table-column>
                <!-- 运营区域为弹性列，吸收表格剩余宽度 -->
                <el-table-column label="运营区域" prop="operationArea" min-width="120" show-overflow-tooltip v-if="$root.isPc"></el-table-column>
                <el-table-column label="职位" prop="position" width="130" show-overflow-tooltip v-if="$root.isPc"></el-table-column>
                <el-table-column label="用工类型" prop="employmentType" width="100" show-overflow-tooltip v-if="$root.isPc"></el-table-column>
                <el-table-column label="状态" width="120" align="center">
                    <template slot-scope="scope">
                        <el-tag size="medium" type="success" v-if="scope.row.status === 1">在职</el-tag>
                        <el-tag size="medium" type="warning" class="mrgl5"
                            v-if="scope.row.status === 1 && scope.row.leaveDate">待离职</el-tag>
                        <el-tag size="medium" type="info" v-if="scope.row.status !== 1">离职</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="入职日期" prop="hireDate" :formatter="formatDate" width="110"></el-table-column>
                <el-table-column label="最后工作日" prop="leaveDate" :formatter="formatDate" width="110"></el-table-column>
                <el-table-column label="合同到期" prop="contractExpireDate" :formatter="formatDate" width="110"></el-table-column>
                <el-table-column label="操作" align="center" width="300" fixed="right">
                    <template slot-scope="scope">
                        <el-button class="op-btn" plain size="mini" @click="_detail(scope.row)">详情</el-button>
                        <el-button class="op-btn" type="primary" plain size="mini" @click="_edit(scope.row)" v-if="isEmployeeArchiveManage">编辑</el-button>
                        <el-button class="op-btn" type="info" plain size="mini" @click="_records(scope.row)">记录</el-button>
                        <el-button class="op-btn op-btn-wide" type="warning" plain size="mini" @click="_leave(scope.row)"
                            v-if="isEmployeeArchiveManage && scope.row.status === 1 && !scope.row.leaveDate">离职</el-button>
                        <el-button class="op-btn op-btn-wide" type="success" plain size="mini" @click="_hire(scope.row)"
                            v-if="isEmployeeArchiveManage && scope.row.status === 2">再次入职</el-button>
                        <!-- 待离职等没有第三个操作的行走，保留占位保证整组按钮对齐 -->
                        <span class="op-placeholder"
                            v-if="isEmployeeArchiveManage && !(scope.row.status === 1 && !scope.row.leaveDate) && scope.row.status !== 2"></span>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pagination-container" v-if="isPagination">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="listQuery.page" :page-sizes="appPageSizes" :page-size="listQuery.size"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
        <!-- 手动入职 -->
        <employee-hire ref="refEmployeeHire" @refreshData="_search()"></employee-hire>
        <!-- 办理离职 -->
        <employee-leave ref="refEmployeeLeave" @refreshData="_search()"></employee-leave>
        <!-- 编辑档案 -->
        <employee-archive-edit ref="refEmployeeArchiveEdit" @refreshData="_search()"></employee-archive-edit>
        <!-- 档案详情 -->
        <employee-archive-detail ref="refEmployeeArchiveDetail"></employee-archive-detail>
        <!-- 入离职记录 -->
        <employee-records ref="refEmployeeRecords" @refreshData="_search()"></employee-records>
        <!-- 钉钉审批同步/钉钉导入 -->
        <employee-import ref="refEmployeeImport" @refreshData="_search()"></employee-import>

        <!-- 功能说明 -->
        <el-dialog title="员工档案页功能说明" :visible.sync="helping" custom-class="c-el-dialog comp-employee-archives-help-dialog">
            <div class="employee-archives-help">
                <p v-for="(line, index) in helpLines" :key="index">{{ line }}</p>
            </div>
            <span slot="footer"><el-button type="primary" @click="helping = false">知道了</el-button></span>
        </el-dialog>
    </div>
</template>

<style lang="scss" scoped>
.op-btn {
    width: 58px;
    padding-left: 0;
    padding-right: 0;
}
.op-btn-wide {
    width: 76px;
}
.op-placeholder {
    display: inline-block;
    width: 76px;
    margin-left: 10px;
}
/deep/ .comp-employee-archives-help-dialog {
    max-width: 640px;

    .employee-archives-help p {
        margin: 0 0 10px;
        line-height: 1.7;

        &:last-child {
            margin-bottom: 0;
        }
    }
}
</style>

<script>
import permission from "@/mixins/permission"
import enumConfigs from "@/mixins/enumConfigs"
import { EmployeeArchives } from "@/mixins/commonPageExport"
import * as funEmployee from "@/api/employees"
import moment from "moment"
import employeeHire from "./components/employeeHire"
import employeeLeave from "./components/employeeLeave"
import employeeArchiveEdit from "./components/employeeArchiveEdit"
import employeeArchiveDetail from "./components/employeeArchiveDetail"
import employeeRecords from "./components/employeeRecords"
import employeeImport from "./components/employeeImport"

export default {
    name: "pageEmployeeArchives",
    mixins: [permission, enumConfigs],
    components: {
        employeeHire,
        employeeLeave,
        employeeArchiveEdit,
        employeeArchiveDetail,
        employeeRecords,
        employeeImport
    },
    data() {
        return {
            tableData: [],
            total: null,
            isPagination: false,
            helping: false,
            helpLines: [
                "身份证号是员工唯一标识，一人一档；离职只改状态不删档，再次入职复用同一档案。",
                "状态按最后工作日实时判定：最后工作日当天仍在职，次日起自动转离职；最后工作日在未来时显示「待离职」。",
                "手动入职/离职、编辑档案、钉钉导入需要「员工档案管理」权限；入离职记录中只有手动记录可以删除，删除后档案状态按剩余记录重算。",
                "两种导入互不相干：「钉钉数据」下拉（同步 / 上传）处理钉钉入职/离职审批；「导入档案」把「导出档案」下载的表格修改后直接回导。",
                "「导入档案」按身份证号匹配：已有档案仅更新 姓名/手机号/运营区域/职位/用工类型/职业技能/银行卡号/开户行/合同到期时间/备注（空单元格保留原值），结果逐字段显示修改内容；已有档案的状态与入离职日期不改（请走入职/离职流程）。",
                "「导入档案」遇到档案不存在的身份证号会自动新增建档：须有姓名和手机号，入职日期取「入职日期」列（缺省按导入当天），带「最后工作日」的行同时写离职记录。",
                "「钉钉数据」的同步与上传都可独立选择入职或离职数据，两者互不阻塞；离职按身份证匹配档案，未匹配会提示先补该员工的入职数据。",
                "「同步」按审批创建时间从钉钉接口拉取，可选择最近 365 天内的任意范围；每日凌晨还会自动同步（先入职后离职）最近 30 天，跨天完成的审批会自动补上。",
                "同步与上传都只导入「已完成 + 审批通过」的审批，按「审批编号 + 身份证号」幂等，重复导入不会重复落库；同一天同类型的重复数据以最后一次导入为准（手动录入的记录优先保留）；入职未命中自动建档，离职按身份证精确匹配。",
                "超过接口 365 天回溯范围的历史数据，请用「钉钉数据 → 上传」分入职、离职两批导入钉钉导出的 .xlsx 文件。",
                "历史离职单没有身份证号时按姓名匹配：唯一同名自动关联并标记「姓名匹配」，多名同名进入「待确认」，选择正确档案后确认离职。",
                "入职日期不能早于上次最后工作日；已有未生效离职记录时不能重复办理离职。",
                "员工保险页列出全部员工（无保险显示「无保险」）；用工类型为「货运 / 无票」的免投保，其余需购保险；筛选「需购买」= 在职且需购且当前无有效保障（无保险/已过期/即将到期）。"
            ],
            listQuery: {
                keywords: "",
                status: null,
                page: 1,
                size: window.$common.appPageSize
            },
            maxExportCount: 20000
        }
    },
    mounted() {
        this.getDataList()
    },
    methods: {
        handleSizeChange(val) {
            window.$common.fullLoading()
            this.listQuery.size = val
            this.getDataList()
        },
        handleCurrentChange(val) {
            window.$common.fullLoading()
            this.listQuery.page = val
            this.getDataList()
        },
        // 获取员工档案列表
        getDataList() {
            window.$common.fullLoading()
            let params = JSON.parse(JSON.stringify(this.listQuery))
            funEmployee.GetEmployeeArchives(params).then(response => {
                window.$common.closeFullLoading()
                this.total = response.totalCount
                this.isPagination = response.totalCount > 0 || false
                if (response && response.items && response.items.length > 0) {
                    this.tableData = response.items
                } else {
                    this.tableData = []
                }
                // element-ui 2.13 右固定列在数据刷新后高度计算偏短，末行按钮会被裁掉下半截，渲染完成后重算布局
                this.$nextTick(() => {
                    this.$refs.employeeTable && this.$refs.employeeTable.doLayout()
                })
                // 兜底：字体/异步渲染导致行高晚长高时，固定列高度可能仍按旧值裁切末行
                setTimeout(() => {
                    this.$refs.employeeTable && this.$refs.employeeTable.doLayout()
                }, 300)
            })
        },
        _search() {
            this.listQuery.page = 1
            this.getDataList()
        },
        // 日期格式化（空值显示空白）
        formatDate(row, column, cellValue) {
            return cellValue ? moment(cellValue).format("YYYY-MM-DD") : ""
        },
        // 手动入职（传 row = 离职员工再次入职）
        _hire(row) {
            this.$refs.refEmployeeHire.open(row)
        },
        // 办理离职
        _leave(row) {
            this.$refs.refEmployeeLeave.open(row)
        },
        // 编辑档案
        _edit(row) {
            this.$refs.refEmployeeArchiveEdit.open(row)
        },
        // 档案详情
        _detail(row) {
            this.$refs.refEmployeeArchiveDetail.open(row)
        },
        // 入离职记录
        _records(row) {
            this.$refs.refEmployeeRecords.open(row)
        },
        // 钉钉数据下拉：同步 = 钉钉审批 API 同步，上传 = 钉钉审批 Excel 导入
        handleDingtalkCommand(command) {
            if (command === "sync") {
                this._sync()
            } else if (command === "upload") {
                this._import()
            }
        },
        // 钉钉审批同步（API 日期范围）
        _sync() {
            this.$refs.refEmployeeImport.open("api")
        },
        // 钉钉导入（钉钉审批 Excel）
        _import() {
            this.$refs.refEmployeeImport.open("excel")
        },
        // 导入档案（导出档案的 Excel 修改后回导）
        _importArchive() {
            this.$refs.refEmployeeImport.open("archive")
        },
        // 导出档案（按当前筛选条件导出全部，列与列表一致；可改后经「导入档案」回导）
        _export() {
            window.$common.fullLoading()
            let params = JSON.parse(JSON.stringify(this.listQuery))
            params.page = 1
            params.size = this.maxExportCount
            funEmployee.GetEmployeeArchives(params).then(response => {
                window.$common.closeFullLoading()
                if (!response || !response.items || response.items.length <= 0) {
                    this.$message.warning("没有需要导出的数据!")
                    return
                }
                if (response.totalCount > this.maxExportCount) {
                    this.$message.warning(`当前筛选条件命中${response.totalCount}条数据，不允许导出超过${this.maxExportCount}条数据，请缩小筛选条件!`)
                    return
                }
                let tableDatas = response.items.map(t => ({
                    ...t,
                    // 状态口径与列表一致：在职（最后工作日在未来时为待离职）/ 离职
                    statusDesc: t.status === 1 ? (t.leaveDate ? "待离职" : "在职") : "离职",
                    hireDateDesc: t.hireDate ? moment(t.hireDate).format("YYYY-MM-DD") : "",
                    leaveDateDesc: t.leaveDate ? moment(t.leaveDate).format("YYYY-MM-DD") : "",
                    contractExpireDateDesc: t.contractExpireDate ? moment(t.contractExpireDate).format("YYYY-MM-DD") : ""
                }))
                EmployeeArchives(`员工档案信息表(${moment().format("YYYY-MM-DD")}).xlsx`, tableDatas)
            })
        }
    }
}
</script>
